<template>
  <svg
    id="Saal_Deutschland"
    data-name="Saal Deutschland"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    :viewBox="show.ui.viewBox"
  >
    <rect
      id="Stage"
      class="cls-1"
      :x="show.ui.stageX"
      :y="show.ui.stageY"
      :width="show.ui.stageWidth"
      :height="show.ui.stageHeight"
      :transform="show.ui.stageTransform"
      style="fill: #464646"
    />

    <text
      v-for="(text, textIndex) of show.ui.labels"
      :key="textIndex"
      :transform="text.transform"
      :style="`fill: #fff;font-size: ${text.fontSize};`"
    >
      {{ text.text }}
    </text>

    <line
      v-for="(line, lineIndex) of show.ui.lines"
      :key="lineIndex"
      :x1="line.x1"
      :y1="line.y1"
      :x2="line.x2"
      :y2="line.y2"
      :style="`stroke:#ffffff;stroke-width:0.5;stroke-miterlimit:9.9997`"
    ></line>
    <polyline
      v-for="(polyline, polyLineIndex) of show.ui.polylines"
      :key="polyLineIndex"
      :points="polyline.points"
      :style="`fill:none;stroke:#ffffff;stroke-width:0.5;stroke-miterlimit:9.9997`"
    ></polyline>
    <circle
      v-for="(seat, seatIndex) of seats"
      :key="seatIndex"
      @mousedown="handleMouseDown"
      @mouseup="(e) => handleMouseUp(e, seat)"
      @touchstart="drag = false"
      @touchmove="handleTouchMove"
      @touchend="onClick(seat)"
      :id="seat.id"
      class="seat"
      :class="{
        SELECTED: isSelected(seat.id),
        'loading-seat': seat.loading,
        [seat.status]: true,
      }"
      :style="`fill:${
        seat.status === 'FREE' ? seat.color : '#E0E0E0'
      };fill-opacity:${
        seat.status === 'PAID' && !isSelected(seat.id) ? '0.15' : '1.0'
      }`"
      :cx="seat.x"
      :cy="seat.y"
      :r="seat.r"
      :transform="seat.transform"
    ></circle>
  </svg>
  <ModalComponent
    :isOpen="guestModalState"
    @modal-close="(e) => (guestModalState = false)"
  >
    <template #content>
      <div class="p-5">
        <div class="text-2xl mb-6">Choose checkout method</div>

        <div
          :class="{ error: v$.email.$invalid && v$.email.$model.length > 1 }"
        >
          <label for="">Enter E-Mail address</label>
          <input
            type="text"
            ref="email"
            v-model="form.email"
            class="w-full px-0 pt-2 border-b-2 border-grey-400 n3-bg-grey outline-none opacity-50 focus:border-n3yellow mb-5"
          />
        </div>

        <a
          href=""
          @click.prevent="onContinueAsGuest"
          class="border-2 sm:px-[2rem] py-3 text-[20px] sm:text-[24px] border-n3grey inline-block disabled:opacity-50 rounded-lg w-full text-center opacity-70"
        >
          Continue as Guest
        </a>
        <div class="text-center my-6 opacity-50 text-xl">OR</div>

        <a
          href=""
          @click.prevent="redirectToLogin()"
          class="border-2 sm:px-[2rem] py-3 text-[20px] sm:text-[24px] border-n3yellow inline-block disabled:opacity-50 rounded-lg w-full text-center"
        >
          N3 Account
        </a>
      </div>
    </template>
  </ModalComponent>
</template>
<script>
import { reactive, toRefs } from "@vue/reactivity";
import { useStore } from "vuex";
import { computed, getCurrentInstance, watch } from "@vue/runtime-core";
import { SeatStatus } from "@/utils/enum";
import { saveStorage } from "@/utils/helper";
import { useRouter } from "vue-router";
import SeatAlreadyOccupiedError from "@/utils/seatAlreadyOccupiedError";
import { useSweetAlert } from "@/composable/useSweetAlert";
import ModalComponent from "@/components/ModalComponent.vue";

import { required, email } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
  name: "SeatSvg",
  components: { ModalComponent },
  setup() {
    const store = useStore();
    const router = useRouter();

    const { proxy } = getCurrentInstance();
    const state = reactive({
      guestModalState: false,
      currentSeat: null,
      drag: false,
      form: {
        email: "",
      },
      event: computed(() => store.state.event.event),
      show: computed(() => store.state.show.show),
      selectedSeats: computed(() => store.state.reservation.selectedSeats),
      reservation: computed(() => store.state.reservation.reservation),
      transactionProgress: computed(() => store.state.show.transactionProgress),
      maxSeatReached: computed(
        () => store.getters["reservation/maxSeatReached"]
      ),
      seats: computed(() => store.state.show.seats),
      isSelected: computed(() => (id) => {
        return state.selectedSeats.findIndex((a) => a.id === id) !== -1;
      }),
      currentUser: computed(() => store.state.auth.currentUser),
      isGuest: computed(() => store.state.auth.isGuest),
      clickSourcePosition: {
        x: 0,
        y: 0,
      },
    });

    const v$ = useVuelidate({ email: { required, email } }, state.form);

    watch(
      () => state.selectedSeats.length,
      (v) => {
        console.log("SEAT UPDATED", v);
      }
    );

    function redirectToLogin() {
      saveStorage("REDIRECT_TO", location.pathname);
      router.push({ name: "login" });
    }

    async function onClick(seat) {
      state.currentSeat = seat;

      if (state.drag) return;
      if (state.show.guestCheckout && !state.currentUser) {
        state.guestModalState = true;
        return;
      }

      if (!state.currentUser && !state.isGuest) {
        redirectToLogin();
        return;
      }

      const index = state.selectedSeats.findIndex((a) => a.id === seat.id);
      if (seat.status === SeatStatus.PAID && index === -1) {
        console.log("Seat already logged....");
        return;
      }
      if (seat.loading || state.transactionProgress) return;

      const { Toast } = useSweetAlert();
      if (state.maxSeatReached && seat.status === SeatStatus.FREE) {
        Toast.fire({
          icon: "warning",
          title: "You have reached maximum seat limit.",
        });

        console.log("Max seat reached...");
        return;
      }
      console.log("Transaction started...", seat.status);
      seat.loading = true;
      store
        .dispatch("show/markSeatAs", {
          seat_id: seat.id,
          status: seat.status,
          isGuest: state.show.guestCheckout && state.guest,
        })
        .then((data) => {
          store.dispatch("reservation/attachReservation", data.reservation);
          store.dispatch("show/attachSeat", data.seat);
          seat.loading = false;
          console.log("Transaction success...");
        })
        .catch((e) => {
          seat.loading = false;
          if (e instanceof SeatAlreadyOccupiedError) {
            Toast.fire({
              icon: "warning",
              title: "Seat already occupied by another user",
            });
          } else {
            console.log("Transaction failed...", e);
          }
        });
    }

    function handleMouseDown(e) {
      state.drag = false;
      state.clickSourcePosition.x = e.clientX;
      state.clickSourcePosition.y = e.clientY;
    }

    function handleMouseUp(e, seat) {
      const xDistance = e.clientX - state.clickSourcePosition.x;
      const yDistance = e.clientY - state.clickSourcePosition.y;

      const c = Math.sqrt(xDistance * xDistance + yDistance * yDistance);
      if (c < 5) {
        onClick(seat);
      }
    }

    function handleTouchMove() {
      setTimeout(() => {
        state.drag = true;
      }, 100);
    }

    function onContinueAsGuest() {
      if (proxy.v$.email.$invalid) {
        const { Toast } = useSweetAlert();
        Toast.fire({
          title: "Enter valid email address!",
          icon: "error",
        });
        return;
      }
      state.guestModalState = false;
      store.dispatch("auth/setAuth", {
        firstName: "Guest",
        name: "Guest",
        email: state.form.email,
      });
      store.dispatch("auth/setGuest", true);
      onClick(state.currentSeat);
    }
    return {
      ...toRefs(state),
      v$,
      onClick,
      redirectToLogin,
      handleMouseDown,
      handleMouseUp,
      handleTouchMove,
      onContinueAsGuest,
    };
  },
};
</script>
<style lang="scss">
.seat-plan {
  .FREE {
    cursor: pointer;
  }
  .SELECTED {
    fill: #ff2a00 !important;
    cursor: pointer;
  }

  .loading-seat {
    cursor: progress;
    animation: fade 1s infinite linear;
  }
}

@keyframes spinnerCircle {
  0% {
    stroke-dashoffset: (7 * 50);
  }
  50% {
    stroke-dashoffset: (3.14 * 50);
  }
  100% {
    stroke-dashoffset: (0.66 * 50);
  }
}

@keyframes fade {
  0%,
  100% {
    opacity: 0.25;
  }
  50% {
    opacity: 1;
  }
}
</style>
